import React from 'react';
import { Card, Badge, Spacer, Row, Col } from '@cleartrip/bento';

function Note({ notes, label }) {
	return (
		<>
			<Spacer className='pt-5 pt-2--xs' />
			<Card className='bg-warning-100 br-4 px-4 py-4 flex flex-middle'>
				<Row className='flex-middle w-100p'>
					<Col span={2} xs={24}>
						<Badge type='warning' size='md'>
							{label}
						</Badge>
					</Col>
					<Col xs={24} className='pt-2--xs'>
						{notes.map((note, idx) => (
							<p key={idx} className='fs-3 c-neutral-700 lh-copy lh-copy--xs pb-1--xs'>{note}</p>
						))}
					</Col>
				</Row>
			</Card>
			<Spacer className='pt-2 pt-0--xs' />
		</>
	);
}

Note.defaultProps = {
	label: 'note',
};

export default Note;
